import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NewsPromotionComponent } from './newspromotion.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule
  ],
  declarations: [NewsPromotionComponent],
  exports: [
    NewsPromotionComponent
  ],
  providers: [
  ]
})
export class NewsPromotionModule { }
